module.exports = __webpack_public_path__ + "static/media/29.44b8eeef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/29.svg
// module id = 146
// module chunks = 0